import React, { memo } from 'react';

import Spinner from '@/ui/components/Spinner';

const PersonHeaderSkeleton = () => {
  return (
    <div className="person-header-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-title">
          <Spinner className="text-xl font-bold" label="Loading Person ..." size={6} />
        </div>
      </div>

      <div className="skeleton-nav">
        <div className="skeleton-text skeleton-select-nav" />
        <div className="skeleton-text skeleton-toolbar" />
      </div>
    </div>
  );
};

export default memo(PersonHeaderSkeleton);
